import {searchModel} from "../../../../Utilities/Search";
import {isNullOrUndefined} from "../../../../Utilities/commonUtilities";
import {isArrayNullOrEmpty} from "../../../../Utilities/Types/arrayUtilities";
import {dynamicSort} from "../../../../Utilities/Sort";

export const loanLibraryCatalogSearchModel = (userId = "", searchTerm = "", catalogNumber = "", mediaFormat: string | null = null, isActive = true) => {
    return Object.assign({}, searchModel(userId.toString(), "productName", false, "productName"), {
        searchTerm: searchTerm,
        catalogNumber: catalogNumber,
        mediaFormat: mediaFormat,
        isActive: isActive,
        ClearCatalogSearch: clearCatalogSearch,
        ApplySorting: applySorting,
    });
};

function clearCatalogSearch(this: Record<string, unknown>) {
    this.searchTerm = "";
    this.catalogNumber = "";
    this.mediaFormat = null;
    this.isActive = true;
    (this as { ClearSearch: (load: boolean) => void }).ClearSearch(false);
}

function applySorting(loanLibraryCatalogSearchCriteria: Record<string, unknown>, items: Record<string, unknown>[]) {
    if (isNullOrUndefined(items) || isArrayNullOrEmpty(items))
        return items;

    return items.sort(dynamicSort(loanLibraryCatalogSearchCriteria.sortByColumn as string, loanLibraryCatalogSearchCriteria.sortDescending as boolean));
}
